import api from 'service/api'

const dponetAPI = api.create('dponet')

const getTitular = async ({ ...params }) => {
  return await dponetAPI.get(`/tickets/titular`, { params })
}

const get = async ({ ticketId = '', ...params }) => {
  return await dponetAPI.get(`/tickets/${ticketId}/titular`, { params })
}

const indexMessages = async ({ ticketId = '', ...params }) => {
  return await dponetAPI.get(`/tickets/${ticketId}/titular/messages`, {
    params,
  })
}

const createMessage = async ({ ticketId, ...data }) => {
  return await dponetAPI.postForm(`/tickets/${ticketId}/titular/messages`, {
    ticketMessages: data,
  })
}

const confirmData = async ({ ticketId, ...params }) => {
  return await dponetAPI.post(
    `/tickets/${ticketId}/titular/confirm_data`,
    params,
  )
}

const submitData = async ({ ticketId, ...data }) => {
  return await dponetAPI.postForm(`/tickets/${ticketId}/titular/submit_data`, {
    ticketMessages: data,
  })
}

const indexResponsibles = async (params) => {
  return await dponetAPI.get(`/tickets/titular/responsibles`, {
    params,
  })
}

const changeResponsibles = async (data) => {
  return await dponetAPI.patch(`/tickets/titular/responsibles`, {
    answerOptionTickets: data,
  })
}

const update = async ({ ticketId, ...data }) => {
  return await dponetAPI.put(`/tickets/${ticketId}/titular`, { ticket: data })
}

const stats = async ({ ...params }) => {
  return await dponetAPI.get(`/tickets/titular/stats`, { params })
}

const titularTickets = {
  changeResponsibles,
  confirmData,
  createMessage,
  get,
  getTitular,
  indexMessages,
  indexResponsibles,
  stats,
  submitData,
  update,
}

export default titularTickets
